module.exports = __webpack_public_path__ + "img/lvyouzhuanbeiyongpin_shrz.810fbc2e.png";